import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const reviews = [
  {
    name: "Christophe A.",
    role: "Local Guide · 200 avis",
    rating: 5,
    text: "Mes proches m'ont offert une séance de bain sonore, et l'expérience a été impressionnante. Les sons traversant le corps, procurant une détente immédiate et profonde. Je suis ressorti calme, relâché... et j'ai étonnamment très bien dormi ensuite. Merci à Larissa et Stephen pour ce lieu magnifique !",
    instrument: "Bain sonore",
  },
  {
    name: "Arnaud M.",
    role: "Local Guide · 26 avis",
    rating: 5,
    text: "Le lieu est magnifique, spacieux, et on ressent tout de suite l'atmosphère dédiée à la pratique. Ici les gongs et les instruments sont d'une qualité exceptionnelle, le ressenti est incomparable.",
    instrument: "Gongs & instruments",
  },
  {
    name: "Justine J.",
    role: "Local Guide · 41 avis",
    rating: 5,
    text: "J'ai participé à un bain sonore avec Larissa et Stephen et c'était magique. Une vraie parenthèse de calme, comme suspendue hors du temps. Merci pour cette belle découverte !",
    instrument: "Bain sonore",
  },
  {
    name: "Cissé G.",
    role: "Local Guide · 48 avis",
    rating: 5,
    text: "Voyage sonore au top. Accueil très agréable. Nous sommes venues en découverte sans connaître l'établissement. Nous avons été ravies de notre séance. On sent que les accueillants sont passionnés par leurs activités, ils aiment faire partager avec bienveillance et pédagogie.",
    instrument: "Voyage sonore",
  },
  {
    name: "Muriel B.",
    role: "10 avis",
    rating: 5,
    text: "Toujours avec son sourire, un accueil chaleureux. Le professionnalisme et la bienveillance de Larissa sont à l'origine du succès de SoundYoga. Le tout accompagné de sympathiques rencontres. On s'y sent bien et on y revient !",
    instrument: "Accueil & accompagnement",
  },
];

export default function Reviews() {
  return (
    <section
      id="avis"
      className="relative py-28 md:py-40 px-6 md:px-12 lg:px-20 bg-sand overflow-hidden"
      data-testid="reviews-section"
    >
      <div className="absolute top-20 right-10 w-[400px] h-[400px] rounded-full bg-terracotta/10 blur-[100px] pointer-events-none" />

      <div className="relative max-w-[1400px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="max-w-3xl mb-16"
        >
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-[1px] bg-terracotta" />
            <span className="text-xs uppercase tracking-[0.3em] text-ink/60">
              Ils parlent de nous
            </span>
          </div>
          <h2 className="font-serif text-5xl md:text-6xl lg:text-7xl font-light leading-[0.95] text-ink">
            Le son <span className="italic-serif text-terracotta">qui rassemble.</span>
          </h2>
          <div className="flex flex-wrap items-center gap-2 mt-8">
            {[...Array(5)].map((_, i) => (
              <Star key={i} size={20} className="fill-[#A8843F] text-[#A8843F]" />
            ))}
            <span className="ml-3 font-serif text-lg text-ink">5,0 / 5</span>
            <span className="text-sm text-ink/55">· basé sur 141 avis Google · partenaire officiel SoundYoga</span>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-5 md:gap-6">
          {reviews.map((r, i) => (
            <motion.div
              key={r.name}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.8, delay: i * 0.1 }}
              className={`relative bg-cream rounded-3xl p-8 md:p-10 border border-ink/8 hover:border-terracotta/30 transition-all hover:-translate-y-1 duration-500 ${i === 4 ? "md:col-span-2" : ""}`}
              data-testid={`review-${i}`}
            >
              <Quote size={28} className="text-terracotta/30 mb-4" />
              <p className="font-serif text-lg md:text-xl text-ink/85 leading-relaxed font-light italic">
                « {r.text} »
              </p>
              <div className="mt-6 pt-6 border-t border-ink/10 flex items-center justify-between gap-4">
                <div>
                  <div className="font-serif text-base text-ink">{r.name}</div>
                  <div className="text-xs text-ink/55">{r.role}</div>
                </div>
                <div className="text-right shrink-0">
                  <div className="flex gap-0.5 justify-end mb-1">
                    {[...Array(r.rating)].map((_, j) => (
                      <Star key={j} size={12} className="fill-[#A8843F] text-[#A8843F]" />
                    ))}
                  </div>
                  <div className="text-[10px] uppercase tracking-[0.18em] text-terracotta font-medium">
                    {r.instrument}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.a
          href="https://share.google/I51L05dGQvSgXW0U2"
          target="_blank"
          rel="noreferrer"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="mt-10 inline-flex items-center gap-2 text-sm text-ink/60 hover:text-terracotta transition"
          data-testid="reviews-google-link"
        >
          Voir tous les avis sur Google →
        </motion.a>
      </div>
    </section>
  );
}
